<template>
    <div>
        <div v-if="tables">
            <v-data-table
                v-model="selectKeys"
                item-key="id"
                :headers="headers"
                :items="data"
                show-select
                disable-pagination
                hide-default-footer
                class="elevation-1"
            >
            
                <template v-slot:item.documentNumber="{item}">
                    <div class="overflow2" @click="goDetail1(item.id)">
                        {{item.documentNumber}}
                    </div>
                </template>
                <template v-slot:item.title="{item}">
                    <div class="overflow2" @click="goDetail1(item.id)">
                        {{item.title}}
                    </div>
                </template>
                <template v-slot:item.inventor="{item}">
                    <div class="overflow2" @click="goDetail1(item.id)">
                        <span style="margin-right: 4px;" v-for="(item1,index1) in item.inventor" :key="index1">{{item1}}</span>
                    </div>
                </template>
                <template v-slot:item.applicationDate="{item}">
                    <div class="overflow2" @click="goDetail1(item.id)">
                        {{item.applicationDate}}
                    </div>
                </template>
                <template v-slot:item.currentAssigneeList="{item}">
                    <div class="overflow2">
                        <span v-for="(item1,index1) in item.currentAssigneeList" :key="index1">{{item1}}</span>
                    </div>
                </template>
                <template v-slot:item.action="{item}">
                    <div class="overflow2">
                        <v-btn @click="getDesc(item)">查看注释</v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>
        <div v-if="imageText" class="imgtext_wrap">
            <div class="flex_style left">
                <v-checkbox
                    v-model="selAll"
                    :indeterminate="isIndeter"
                >
                </v-checkbox>
                <span>选中本页</span>
            </div>
            <v-data-iterator
                :items="data"
                item-key="id"
                @input="getSelectKeys"
                disable-pagination
                hide-default-footer
                >            
                 <template v-slot:default="{items}"> 
                     <!-- ,isSelected, select -->
                    <!-- <v-card v-for="item in items" :key="item.id" class="item"> -->
                        <v-list dense>
                            <v-list-item-group
                            v-model="selectKeys"
                            multiple
                            color="primary"
                            >
                            <v-card v-for="item in items" :key="item.id" class="item">
                                <div class="icon">
                                    <v-list-item  :value="item.id" >
                                        <template v-slot:default="{active}">
                                                <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                            <v-list-item-content v-if="false">
                                                <div class="center">
                                                    <div class="lefts">
                                                        <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                                        <!-- <v-checkbox :input-value="isSelected(item)" :label="isSelected(item) ? '' : ''" @click="(v)=>select(item, !isSelected(item))"> </v-checkbox>   -->
                                                        <div class="img_icon">
                                                            <img :src="$store.state.baseUrl + item.imagePath" alt="">
                                                        </div>
                                                    </div>
                                                    <div class="rights hand" @click="goDetail1(item.id)">
                                                        <div class="num h32">{{item.documentNumber}}</div>
                                                        <div class="title">{{item.title}}</div>
                                                        <div class="text_wrapper"><span class="tag_icon">{{item.legalStatus}}</span><span class="tag_icon">{{item.type}}</span></div>
                                                        <div class="text_wrapper"><label class="text">公开(公告)号：</label><span>{{item.documentNumber}}</span></div>
                                                        <div class="text_wrapper"><label class="text">申请号：</label><span>{{item.applicationNumber}}</span></div>
                                                        <div class="text_wrapper"><label class="text">申请日：</label><span>{{item.applicationDate}}</span></div>
                                                        <div class="text_wrapper"><label class="text" v-if="item.inventor">发明人：</label><span v-for="(item1,index) in item.inventor" :key="index">{{item1}}</span></div>
                                                        <div class="text_wrapper"><label class="text" v-if="item.applicant">申请人：</label><span v-for="(item1,index) in item.applicant" :key="index">{{item1}}</span></div>
                                                        <div class="text_wrapper"><label class="text" v-if="item.assignee">专利权人：</label>{{item.assignee}}</div>
                                                        <div class="text_wrapper"><label class="text" v-if="item.currentAssigneeList">当前专利权人：</label><span v-for="(item1,index) in item.currentAssigneeList" :key="index">{{item1}}</span></div>
                                                        <!-- <div class="text_wrapper"><label class="text">代理人：</label><span v-for="(item1,index) in item.agent" :key="index">{{item1}}</span></div> -->
                                                        <!-- <div class="text_wrapper"><label class="text">代理机构：</label> <span>{{item.agency}}</span></div> -->
                                                        <div class="text_wrapper"><label class="text" v-if="item.ipc">IPC分类号：</label> <span v-for="(item1,index) in item.ipc" :key="index">{{item1}}</span></div>
                                                        <div class="text_wrapper" v-if="item.cpc"><label class="text">CPC分类号：</label><span v-for="(item1,index) in item.cpc" :key="index">{{item1}}</span></div>
                                                        <!-- <div class="text_wrapper"><label class="text">权利要求数：</label> <span>{{item.claimsCount}}</span></div> -->
                                                        <div class="text_wrapper" v-if="item.summary"><label class="text">摘要：</label> <span>{{item.summary}}</span></div>
                                                    </div>
                                                </div>
                                            </v-list-item-content>
                                        </template>
                                    </v-list-item>
                                </div>
                                <div class="center hand" @click="goDetail1(item.id)">
                                    <div class="lefts">
                                        <div class="img_icon">
                                            <img :src="$store.state.baseUrl + item.imagePath" alt="">
                                        </div>
                                    </div>
                                    <div class="rights hand">
                                        <div class="num">{{item.documentNumber}}</div>
                                        <div class="title">{{item.title}}</div>
                                        <div class="text_wrapper"><span class="tag_icon">{{item.legalStatus}}</span><span class="tag_icon">{{item.type}}</span></div>
                                        <div class="text_wrapper"><label class="text">公开(公告)号：</label><span>{{item.documentNumber}}</span></div>
                                        <div class="text_wrapper"><label class="text">申请号：</label><span>{{item.applicationNumber}}</span></div>
                                        <div class="text_wrapper"><label class="text">申请日：</label><span>{{item.applicationDate}}</span></div>
                                        <div class="text_wrapper"><label class="text" v-if="item.inventor">发明人：</label><span v-for="(item1,index) in item.inventor" :key="index">{{item1}}</span></div>
                                        <div class="text_wrapper"><label class="text" v-if="item.applicant">申请人：</label><span v-for="(item1,index) in item.applicant" :key="index">{{item1}}</span></div>
                                        <div class="text_wrapper"><label class="text" v-if="item.assignee">专利权人：</label>{{item.assignee}}</div>
                                        <div class="text_wrapper"><label class="text" v-if="item.currentAssigneeList">当前专利权人：</label><span v-for="(item1,index) in item.currentAssigneeList" :key="index">{{item1}}</span></div>
                                        <!-- <div class="text_wrapper"><label class="text">代理人：</label><span v-for="(item1,index) in item.agent" :key="index">{{item1}}</span></div> -->
                                        <!-- <div class="text_wrapper"><label class="text">代理机构：</label> <span>{{item.agency}}</span></div> -->
                                        <div class="text_wrapper"><label class="text" v-if="item.ipc">IPC分类号：</label> <span v-for="(item1,index) in item.ipc" :key="index">{{item1}}</span></div>
                                        <div class="text_wrapper" v-if="item.cpc"><label class="text">CPC分类号：</label><span v-for="(item1,index) in item.cpc" :key="index">{{item1}}</span></div>
                                        <!-- <div class="text_wrapper"><label class="text">权利要求数：</label> <span>{{item.claimsCount}}</span></div> -->
                                        <div class="text_wrapper" v-if="item.summary"><label class="text">摘要：</label> <span>{{item.summary}}</span></div>
                                    </div>
                                </div>
                            </v-card>
                            </v-list-item-group>
                        </v-list>
                    <!-- </v-card> -->
                </template> 
            </v-data-iterator>
        </div>
        <div v-if="fullText">
            <div class="imgtext_wrap">
                <div class="flex_style left">
                    <v-checkbox
                        v-model="selAll"
                        :indeterminate="isIndeter">
                    </v-checkbox>
                    <span>选中本页</span>
                </div>
                <v-list class="patent_list">
                    <v-list-item-group
                        v-model="selectKeys"
                        multiple
                        color="primary"
                        >
                        <v-row class="item_wrapper1"> 
                            <v-col xs="12" sm="6" md="4" lg="3" xl="2" v-for="(item,index) in data" :key="index">
                                <div class="item_box">
                                    <v-list-item :value="item.id" class="icon">
                                        <template v-slot:default="{active}">
                                            <!-- <v-list-item-content  :title="item.title"> -->
                                                <v-checkbox :input-value="active"  color="primary"></v-checkbox>  
                                            <!-- </v-list-item-content> -->
                                        </template>
                                    </v-list-item>
                                    <div class="content hand" @click="goDetail1(item.id)">
                                        <div class="img">
                                            <img :src="$store.state.baseUrl + item.imagePath" alt="">
                                        </div>
                                        <div class="text">
                                            {{item.documentNumber}}
                                        </div>
                                        <div class="text">
                                            {{item.title}}
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-list-item-group>
                </v-list>
            </div>
        </div>
        <!-- 注释弹窗 -->
        <v-dialog
            v-model="dialog"
            width="500">
            <v-card>
                <v-card-title class="headline lighten-2">注释设置</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="marg8">
                        <v-btn @click="addDesp">添加注释</v-btn>
                    </div>
                    <div class="comment_list_wrapper">
                        <div class="flex_style left line">
                            <div class="td1">注释</div>
                            <div class="td2">编辑者</div>
                            <div class="td3">操作</div>
                        </div>
                        <div class="flex_style left line" v-for="item in commentList" :key="item.id">
                            <div class="td1 tit_overflow" :title="item.content">{{item.content}}</div>
                            <div class="td2">{{item.user.nickName}}</div>
                            <div class="td3">
                                <span class="btn" @click="editDesc(item)">编辑</span>
                                <span class="btn" @click="delDesc(item)">删除</span>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn
                    color="primary"
                    text
                    @click="handleDescCancel">
                    取消
                </v-btn> -->
                <v-btn
                    color="primary"
                    text
                    @click="handleDescCancel">
                    关闭
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addVisible" width="500">
            <v-card>
                <v-card-title class="lighten-2">{{visibleTit}}</v-card-title>
                <v-card-text>
                    <div class="common_input_style">
                        <v-text-field
                            v-model="content"
                            label="注释"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入注释"
                        ></v-text-field>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleAddCancel">取消</v-btn>
                    <v-btn color="primary" @click="handleEditOk" v-if="visibleTit =='修改注释'">确定</v-btn>
                    <v-btn color="primary" @click="handleAddOk" v-if="visibleTit =='添加注释'">确定</v-btn>
                </v-card-actions>
            </v-card>
         </v-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: ['showList','result','fid'],
    data() {
        return {
            ids: [],
            data: [],
            folderId: '',
            isIndeter: false,
            selAll: false,
            selectedItem: [],
            singleSelect: false,
           tables: true,
           imageText: false,
            fullText: false,
            pageSize: 10,
            total: 0,
            length: 2,
            page: 1,
            desp: '',
            selectKeys: [],
            isSelectable: true,
            headers: [
                {
                    text: '公开（公告）号',
                    align: 'start',
                    sortable: false,
                    value: 'documentNumber'
                },
                {
                    text: '标题',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: '发明人',
                    align: 'start',
                    sortable: false,
                    value: 'inventor'
                },
                {
                    text: '申请日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
                {
                    text: '法律状态/事件',
                    align: 'start',
                    sortable: false,
                    value: 'legalStatus'
                },
                {
                    text: '申请人',
                    align: 'start',
                    sortable: false,
                    value: 'applicant'
                },
                {
                    text: '当前专利权人',
                    align: 'start',
                    sortable: false,
                    value: 'currentAssigneeList'
                },
                {
                    text: '注释',
                    align: 'start',
                    sortable: false,
                    value: 'action'
                },
            ],
            dialog: false,
            commentList: [],
            udn: '',
            addVisible: false,
            visibleTit: '添加注释',
            content: '',
            commentId: ''
        }
    },
    watch: {
        showList(val) {
            this.tables = val.tables
            this.imageText = val.imageText
            this.fullText = val.fullText
        },
        selectKeys(val) {
            if(val.length>= this.ids.length) {
               this.selAll = true
               this.isIndeter = false
            }else if( val.length>0) {
                this.isIndeter = true
            }else {
                this.selAll = false
                this.isIndeter = false
            }
        },
        selAll(val) {
            if(val) {
                this.selectKeys = this.ids
            }else {
                this.selectKeys = []
            }
        },
        result(val) {
            let ids = []
            if(val.length>0) {
                val.forEach((item)=>{
                    ids.push(item.id)
                })
                this.ids = ids
            }
            this.data = val
        },
        fid(val) {
            this.folderId = val
        }
    },
    mounted() {
        // this.total = this.data.length
        this.tables = this.showList.tables
        this.imageText = this.showList.imageText
        this.fullText = this.showList.fullText
    },
    methods: {
        ...mapActions('space',['getDescList','addDesc','updateDesc','deleteDesc']),
        test(value) {
            console.log('ddddd-value', value)
            console.log('ddddd-value-target', value.target)
            console.log('ddddd-value-returnValue', value.returnValue)
        },
        successTips(val) {
            this.$message({
                type: 'success',
                message: val
            }); 
        },
        failTips(val) {
            this.$message({
                type: 'error',
                message: val
            }); 
        },
        getSelectKeys(val) {
            console.log('val', val)
        },
        getDesc(val) {
            this.dialog = true
            this.udn = val.udn
            this.getList()
        },
        handleDescOk() {
            this.dialog = true
        },
        handleDescCancel() {
            this.dialog = false
        },
        getList() {
            let data = {
                params: {
                    folderId: this.folderId,
                    udn: this.udn
                }
            }
            let _this = this
            this.getDescList({data: data,handle(res) {
                _this.commentList = res.comments
            }})
        },
        editDesc(val) {
            this.content = val.content
            this.commentId = val.id
            this.addVisible = true
            this.visibleTit ='修改注释'
        },
        addDesp() {
            this.addVisible = true
            this.visibleTit ='添加注释'
        },
        handleEditOk() {
            let _this = this
            let data = {
                params: {
                    folderId: this.folderId,
                    commentId: this.commentId,
                    content: this.content
                }
            }
            this.updateDesc({data: data,handle(res) {
                _this.addVisible = false
                if(res.success) {
                    _this.getList()
                    _this.successTips(res.message)
                }else {
                    _this.failTips(res.message)
                }
            }})
        },
        handleAddOk() {
            let _this = this
            let data = {
                params: {
                    folderId: this.folderId,
                    udn: this.udn,
                    content: this.content
                }
            }
            this.addDesc({data: data,handle(res) {
                _this.addVisible = false
                _this.content = ''
                if(res.success) {
                    _this.getList()
                    _this.successTips(res.message)
                }else {
                    _this.failTips(res.message)
                }
            }})
        },
        handleAddCancel() {
            this.addVisible = false
        },
        delDesc(val) {
            this.$msgbox.confirm('此操作将永久删除该注释, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        folderId: this.folderId,
                        commentId: val.id
                    }
                }
                let _this = this
                this.deleteDesc({data: data,handle(res) {
        
                    if(res.success) {
                        _this.getList()
                        _this.successTips(res.message)
                    }else {
                        _this.failTips(res.message)   
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        goDetail(val,items) {
           
            let id = items.item.id
            this.$router.push({
                path: '/search/patentInfo/'+ id,
            })
        },
        goDetail1(val) {
           
            this.$router.push({
                path: '/search/patentInfo/'+ val,
                query: {
                    from: 'space'
                }
            })
        },
    }
}
</script>